export default [
  {
    path: '/financial',
    name: 'Financial',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'app.financial.title',
        showCard: false,
        pageContent: () => import('App/financial/Financial.vue'),
      },
    },
  },
  {
    path: '/financial/payable-accounts',
    name: 'PaybleAccounts',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'app.financial.payableAccounts.title',
        navigateBackRoute: 'Financial',
        pageContent: () => import('App/financial/PayableAccountsCrudList.vue'),
        filterDialogComponent: () => import('App/financial/PayableAccountsFilter.vue'),
        anyComponent: () => import('App/financial/PayableAccountsTerminateButton.vue'),
      },
    },
  },
  {
    path: '/financial/sgv-payments',
    name: 'SgvChargePaymentsList',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'app.financial.chargePayment.pageTitle',
        navigateBackRoute: 'Financial',
        pageContent: () => import('App/financial/sgv-charge-payments/SgvChargePaymentsList.vue'),
        filterDialogComponent: () => import(
            'App/financial/sgv-charge-payments/SgvChargePaymentsFilter.vue'
          ),
      },
    },
  },
  {
    path: '/financial/lotes',
    name: 'LotesPurchaseList',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'Lotes de prorrogações',
        navigateBackRoute: 'Financial',
        btnText: 'Recompras elegíveis',
        newRouteName: 'RepurchaseList',
        pageContent: () => import('App/financial/repurchase/LotesPurchaseList.vue'),
        anyComponent: () => import('App/financial/repurchase/components/LoansTerminateButton.vue'),
        filterDialogComponent: () => import('App/financial/repurchase/components/RepurchaseTerminateButton.vue'),
      },
    },
  },
  {
    path: '/financial/:id/repurchase',
    name: 'RepurchaseLoteList',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'Prorrogações compradas',
        navigateBackRoute: 'LotesPurchaseList',
        pageContent: () => import('App/financial/repurchase/RepurchaseListLoans.vue'),
      },
    },
  },
  {
    path: '/financial/repurchase',
    name: 'RepurchaseList',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'Prorrogações passiveis de compra',
        navigateBackRoute: 'LotesPurchaseList',
        pageContent: () => import('App/financial/repurchase/RepurchaseList.vue'),
        anyComponent: () => import('App/financial/repurchase/components/RepurchaseModal.vue'),
      },
    },
  },
  {
    path: '/financial/tax/group',
    name: 'taxGroup',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'Controle de taxas por grupo',
        navigateBackRoute: 'Financial',
        btnText: 'Adicionar',
        newRouteName: 'taxGroupAdd',
        pageContent: () => import('App/financial/tax/group/TaxGroupCrudList.vue'),
      },
    },
  },
  {
    path: '/financial/tax/group/new',
    name: 'taxGroupAdd',
    component: () => import('App/financial/tax/group/TaxGroupForm.vue'),
    meta: {
      itemActive: 'Financial',
    },
  },
  {
    path: '/financial/tax/group/:id',
    name: 'taxGroupEdit',
    component: () => import('App/financial/tax/group/TaxGroupForm.vue'),
    meta: {
      itemActive: 'Financial',
    },
  },
  {
    path: '/financial/tax/score',
    name: 'taxScore',
    component: () => import('Support/layout/CrudListTemplate.vue'),
    meta: {
      itemActive: 'Financial',
      crud: {
        pageTitle: 'Controle de taxas por score',
        navigateBackRoute: 'Financial',
        btnText: 'Adicionar',
        newRouteName: 'taxScoreAdd',
        pageContent: () => import('App/financial/tax/score/TaxScoreList.vue'),
      },
    },
  },
  {
    path: '/financial/tax/score/new',
    name: 'taxScoreAdd',
    component: () => import('App/financial/tax/score/TaxScoreForm.vue'),
    meta: {
      itemActive: 'Financial',
    },
  },
  {
    path: '/financial/tax/score/:id',
    name: 'taxScoreEdit',
    component: () => import('App/financial/tax/score/TaxScoreForm.vue'),
    meta: {
      itemActive: 'Financial',
    },
  },
];
